<template>
  <div v-if="appointment">
    <!-- page-summ -->
    <div class="page-summ bg--white">
      <section class="summ-head bg--blue center relative tx--bege desk-hide">
        <h2 class="title">סיכום ייעוץ רופא</h2>
        <BackWhite @click="$router.go(-1)" />
      </section>
      <div class="desk_inner_width">
        <div class="hold-all-sum-surg">
          <section class="summ-top relative">
            <div class="padd-20 flex desk-flex--start">
              <div class="logo">
                <Logo />
              </div>
              <div class="clinic-logo flex flex--content--center">
                <Logo />
              </div>
            </div>
            <div class="padd-20 flex border-top">
              <div class="text let-1 center mb-15">
                שם מרפאה: {{ appointment.room }}, כתובת מרפאה
                {{ appointment.address }}
              </div>
              <div class="flex w-100 summ-top-btns no-print">
                <button
                  class="bt_blue flex flex--content--center "
                  :class="{ bt_disable: documents.length == 0 }"
                >
                  <Pdf />
                  <span>הורדת PDF</span>
                </button>
                <button
                  class="bt_blue flex flex--content--center"
                  @click="print"
                >
                  <Print />
                  <span>הדפסה</span>
                </button>
              </div>
            </div>
          </section>
          <section class="summ-main">
            <h2 class="bg--bege title tx--blue2">פרטי מטופל</h2>
            <div class="padd-20">
              <div class="title--30">
                {{ appointment.firstName + " " + appointment.lastName }}
              </div>
              <div class="flex">
                <div class="m-col-50 tx-400">ת.ז</div>
                <div class="m-col-50">{{ appointment.passport }}</div>
              </div>
              <div class="flex">
                <div class="m-col-50 tx-400">תאריך לידה</div>
                <div class="m-col-50">
                  {{
                    $moment(appointment.birthDate, "YYYY-MM-DD").format(
                      "DD/MM/YYYY"
                    )
                  }}
                </div>
              </div>
              <div class="flex">
                <div class="m-col-50 tx-400">טלפון</div>
                <div class="m-col-50">
                  {{ appointment.phone }}
                </div>
              </div>
            </div>
            <h2
              class="bg--bege title tx--blue2"
              v-show="appointment.patient_complaint"
            >
              סיבת הפנייה / תלונה עיקרית
            </h2>
            <div class="padd-20" v-html="appointment.patient_complaint"></div>
            <h2
              class="bg--bege title tx--blue2"
              v-show="appointment.physical_exam"
            >
              בדיקה גופנית
            </h2>
            <div class="padd-20" v-html="appointment.physical_exam"></div>
            <h2
              class="bg--bege title tx--blue2"
              v-show="appointment.recommendations"
            >
              הפנייה לבדיקות להמשך טיפול
            </h2>
            <div class="padd-20" v-html="appointment.recommendations"></div>
            <h2 class="bg--bege title tx--blue2">
              פרטי רופא ופרטי תור
            </h2>
            <div class="padd-20 desk-flex desk-flex--top">
              <div class="flex fin-sum-right">
                <div class="m-col-50">שם הרופא</div>
                <div class="m-col-50 tx-400">{{ doctor.heb_name }}</div>
              </div>
              <div class="flex" v-if="doctor.job_title">
                <div class="m-col-50">התמחות</div>
                <div class="m-col-50 tx-400">{{ doctor.job_title }}</div>
              </div>
              <div class="frame-sign-wrap">
                <div class="frame-sign"></div>
                <div class="center tx-400">חתימת הרופא</div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArrowBackSvg from "../../../assets/img/svg/arrow_back.svg";
import CalendarSvg from "../../../assets/img/svg/doc-calander.svg";
import FileSvg from "../../../assets/img/svg/ic-file.svg";
import TrashSvg from "../../../assets/img/svg/trash.svg";
import BackWhite from "@/assets/img/svg/back-white.svg";
import Logo from "@/assets/img/svg/logo.svg";
import Pdf from "@/assets/img/svg/ic-pdf.svg";
import Print from "@/assets/img/svg/ic-print.svg";

import CancelPop from "../../Popups/CancelApp";
import Error from "@/components/Popups/Error";
export default {
  name: "AppSummery",
  data() {
    return {
      appointment: null,
      doctor: null,
      documents: []
    };
  },
  beforeMount() {
    this.$API
      .getAppointmentInfo(this.$route.params.id)
      .then(res => {
        this.appointment = res.message.appointment;
        this.doctor = res.message.doctor;
        this.documents = res.message.documents;
      })
      .catch(e => {
        this.$modal.show(Error);
      });
  },
  methods: {
    editApp() {
      this.$router.push("/app-edit/" + this.$route.params.id);
    },
    cancelPop() {
      this.$modal.show(
        CancelPop,
        {
          appointment_id: this.$route.params.id,
          appDate: this.appointment.start_datetime.substring(0, 10)
        },
        {
          clickToClose: true
        }
      );
    },
    print() {
      window.focus();
      window.print();
    }
  },
  computed: {
    appointmentPassed() {
      if (this.appointment) {
        let today = this.$moment();
        let appoitment_time = this.$moment(
          new Date(this.appointment.start_datetime)
        );
        if (today.isAfter(appoitment_time)) {
          return true;
        }
      }
      return false;
    }
  },
  components: {
    BackWhite,
    Logo,
    Pdf,
    Print
    // CalendarSvg,
    // FileSvg,
    // TrashSvg
  }
};
</script>

<style scoped></style>
